module.exports = __webpack_public_path__ + "img/recieptReview.1d64780f.png";